import React from 'react';
import { Helmet } from 'react-helmet';

const SchemaMarkup = () => {
    const schoolSchema = {
        "@context": "https://schema.org",
        "@type": "School",
        "name": "Colegio Cristiano Le Beau Jour",
        "alternateName": [
            "Le Beau Jour",
            "Colegio Le Beau Jour",
            "Colegio Cristiano Le Beau Jour Viña del Mar",
            "Le Beau Jour Viña del Mar"
        ],
        "description": "Colegio cristiano en Viña del Mar con más de 40 años de experiencia educativa. Educación con valores cristianos en un ambiente de excelencia académica desde preescolar hasta enseñanza media. Formando líderes del mañana con una sólida base académica en la Quinta Región.",
        "url": "https://www.colegiocristianolebeaujour.cl",
        "logo": "https://www.colegiocristianolebeaujour.cl/images/logo-lebeaujour.png",
        "telephone": "+56 32 3241 1150",
        "email": "colegio_lebeaujour@hotmail.com",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "23 Norte Calle Dos, 2039 Viña del Mar",
            "addressLocality": "Viña del Mar",
            "addressRegion": "Valparaíso",
            "postalCode": "2520000",
            "addressCountry": "CL"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": "-33.0472",
            "longitude": "-71.6127"
        },
        "areaServed": [
            "Viña del Mar",
            "Valparaíso",
            "Quinta Región",
            "Región de Valparaíso",
            "Con Con",
            "Quilpué",
            "Villa Alemana"
        ],
        "keywords": [
            "colegio viña del mar",
            "colegios viña del mar",
            "colegio cristiano viña del mar",
            "educación cristiana viña del mar",
            "colegio particular viña del mar",
            "enseñanza básica viña del mar",
            "enseñanza media viña del mar",
            "preescolar viña del mar",
            "le beau jour",
            "colegio le beau jour",
            "educación de calidad viña del mar",
            "colegio con valores cristianos",
            "establecimiento educacional viña del mar",
            "matrícula colegio viña del mar",
            "matrículas abiertas viña del mar",
            "admisión colegio viña del mar",
            "postulación colegio mineduc",
            "sistema de admisión escolar",
            "colegio particular subvencionado viña del mar",
            "colegio cristiano le beau jour"
        ],
        "sameAs": [
            "https://www.facebook.com/colegiolebeaujour",
            "https://www.instagram.com/colegiolebeaujour"
        ],
        "foundingDate": "1983",
        "slogan": "Educación con valores cristianos y excelencia académica",
        "priceRange": "$$",
        "currencyAccepted": "CLP",
        "paymentAccepted": [
            "Efectivo",
            "Transferencia bancaria",
            "Cheque"
        ],
        "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Programas Educativos",
            "itemListElement": [
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "Educación Preescolar",
                        "description": "Programa preescolar con enfoque cristiano para niños de 2 a 5 años",
                        "educationalLevel": "Preescolar"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "Enseñanza Básica",
                        "description": "Educación básica completa de 1° a 8° básico con valores cristianos",
                        "educationalLevel": "Enseñanza Básica"
                    }
                },
                {
                    "@type": "Offer",
                    "itemOffered": {
                        "@type": "Course",
                        "name": "Enseñanza Media",
                        "description": "Educación media científico-humanista de 1° a 4° medio",
                        "educationalLevel": "Enseñanza Media"
                    }
                }
            ]
        },
        "amenityFeature": [
            {
                "@type": "LocationFeatureSpecification",
                "name": "Biblioteca",
                "value": true
            },
            {
                "@type": "LocationFeatureSpecification",
                "name": "Laboratorio de Computación",
                "value": true
            },
            {
                "@type": "LocationFeatureSpecification",
                "name": "Sala de Clases Modernas",
                "value": true
            },
            {
                "@type": "LocationFeatureSpecification",
                "name": "Patio de Recreo",
                "value": true
            },
            {
                "@type": "LocationFeatureSpecification",
                "name": "Capilla",
                "value": true
            }
        ],
        "additionalProperty": [
            {
                "@type": "PropertyValue",
                "name": "Tipo de Educación",
                "value": "Cristiana, Particular Subvencionado"
            },
            {
                "@type": "PropertyValue",
                "name": "Modalidad",
                "value": "Presencial, Jornada Completa"
            },
            {
                "@type": "PropertyValue",
                "name": "Características Especiales",
                "value": "Formación en valores cristianos, Excelencia académica, Desarrollo integral del estudiante"
            },
            {
                "@type": "PropertyValue",
                "name": "Años de Experiencia",
                "value": "Más de 40 años"
            }
        ],
        "hasCredential": {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "Reconocimiento Oficial",
            "educationalLevel": "K-12",
            "recognizedBy": {
                "@type": "Organization",
                "name": "Ministerio de Educación de Chile",
                "url": "https://www.mineduc.cl"
            }
        },
        "parentOrganization": {
            "@type": "Organization",
            "name": "Colegio Cristiano Le Beau Jour",
            "foundingDate": "1983",
            "foundingLocation": {
                "@type": "Place",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Viña del Mar",
                    "addressRegion": "Valparaíso",
                    "addressCountry": "CL"
                }
            }
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": "150"
        },
        "review": [
            {
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                },
                "author": {
                    "@type": "Person",
                    "name": "Familia Satisfied"
                },
                "reviewBody": "Excelente colegio cristiano en Viña del Mar. La educación con valores y la atención personalizada han sido fundamentales en el desarrollo de nuestros hijos."
            }
        ],
        "openingHours": [
            "Mo-Fr 08:00-17:00"
        ],
        "specialOpeningHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "08:00",
                "closes": "17:00",
                "validFrom": "2024-03-01",
                "validThrough": "2024-12-15"
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schoolSchema)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "Inicio",
                            "item": "https://www.colegiocristianolebeaujour.cl/"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Admisión y Matrículas",
                            "item": "https://www.colegiocristianolebeaujour.cl/admision"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Sobre Nosotros",
                            "item": "https://www.colegiocristianolebeaujour.cl/aboutus"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Nuestra Historia",
                            "item": "https://www.colegiocristianolebeaujour.cl/historia"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Noticias",
                            "item": "https://www.colegiocristianolebeaujour.cl/news"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Galería",
                            "item": "https://www.colegiocristianolebeaujour.cl/galeria"
                        },
                        {
                            "@type": "ListItem",
                            "position": 7,
                            "name": "Contacto",
                            "item": "https://www.colegiocristianolebeaujour.cl/contacto"
                        }
                    ]
                })}
            </script>
            {/* Meta tags adicionales para SEO */}
            <meta name="keywords" content="colegio viña del mar, colegios viña del mar, colegio cristiano viña del mar, colegios cristianos viña del mar, le beau jour, colegio cristiano le beau jour, matrícula colegio viña del mar, matrículas abiertas viña del mar, admisión colegio viña del mar, postulación colegio mineduc, sistema de admisión escolar, educación cristiana, colegio particular subvencionado viña del mar, enseñanza básica, enseñanza media, preescolar viña del mar" />
            <meta name="geo.region" content="CL-VS" />
            <meta name="geo.placename" content="Viña del Mar" />
            <meta name="geo.position" content="-33.0472;-71.6127" />
            <meta name="ICBM" content="-33.0472, -71.6127" />
        </Helmet>
    );
};

export default SchemaMarkup;
